// extracted by mini-css-extract-plugin
export default {"label":"Date_label__2Noc6","asLabel":"Date_asLabel__FnDtI","input":"Date_input__SYEXJ"};